import { Toaster } from '@repo/ui/src/components/ui/sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { DevPaletteBox } from './components/dev/palette/box';
import { router } from './router';

// i18n must be imported before any component that uses useTranslation
import './i18n';

// Re-apply a dev-selected palette override (dev only, no-op in prod)
import { initDevPalette } from './components/dev/palette/apply';
initDevPalette();

// Make sure global styles from ui package are imported
import '@repo/ui/src/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster richColors position="bottom-right" />
      <DevPaletteBox />
    </QueryClientProvider>
  );
}
